/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_HeadingInputs */

const tr_mesafeli_s3_heading = /** @type {(inputs: Mesafeli_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Tanımlar`)
};

const en_mesafeli_s3_heading = /** @type {(inputs: Mesafeli_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Definitions`)
};

const de_mesafeli_s3_heading = /** @type {(inputs: Mesafeli_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Begriffsbestimmungen`)
};

const ru_mesafeli_s3_heading = /** @type {(inputs: Mesafeli_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Определения`)
};

/**
* | output |
* | --- |
* | "3. Definitions" |
*
* @param {Mesafeli_S3_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_heading = /** @type {((inputs?: Mesafeli_S3_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_heading(inputs)
	if (locale === "de") return de_mesafeli_s3_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s3_heading(inputs)
	return tr_mesafeli_s3_heading(inputs)
});